<!--首页-->
<template>
	<div class="main">
		<!-- <Header fixed title="帮好友助力，高端账号免费玩"></Header> -->
		<div class="banner"><img src="/static/images/forfree/banner.jpg" /></div>
		<section class="c_box game_detail" v-if="goodsInfo.goodsTitle">
			<h2>{{ goodsInfo.goodsTitle }}</h2>
			<div class="qufu">
				<span>游戏区服</span>
				{{ goodsInfo.gameAllName }}
			</div>
		</section>
		<section class="c_box account_detail" v-if="goodsInfo.gameId == 1109 && goodsInfo.prototypelist">
			<header class="title_default">账号信息</header>
			<div class="ctn">
				<table class="account_detail_tab">
					<tr v-for="(item, index) in goodsInfo.prototypelist">
						<td>{{ item.keyName }}</td>
						<td>{{ item.value }}</td>
					</tr>
				</table>
			</div>
		</section>

		<section class="c_box account_describe">
			<header class="title_default">账号描述</header>
			<div>
				<p class="c_gray">{{ goodsInfo.remark }}</p>
			</div>
		</section>

		<section class="c_box account_screenshot">
			<header class="title_default">账号截图</header>
			<div class="swiper-container swiper-goodsImg" v-if="goodsInfo.picture && goodsInfo.picture.length > 0">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item, index) in goodsInfo.picture">
						<img :src="item.location" />
					</div>
				</div>
				<!-- Add Pagination -->
				<div class="swiper-pagination"></div>
			</div>
		</section>

		<button class="zuliBtn" @click="zuliSubmit">帮TA助力 免费玩</button>

		<div class="pageModal" v-show="isShowCon">
			<img src="/static/images/forfree/gift1.png" class="modalImg" v-if="iscont" />
			<img src="/static/images/forfree/gift2.png" class="modalImg" v-else />
			<img src="/static/images/forfree/close2.png" class="close" @click="closeBtn" />
			<div class="tit" v-if="iscont">助力成功</div>
			<div class="tit" v-else>助力失败</div>
			<div class="con" v-if="iscont">已帮助好友获得免费体验机会</div>
			<div class="con" v-else>{{ cont }}</div>
			<a class="fbtn" :href="freePlayUrl" v-if="isShowBtn">我也要免费体验</a>
			<a class="fbtn" @click="closeBtn" v-else>确定</a>
		</div>
		<div class="mask" v-show="isMask"></div>
	</div>
</template>

<script>
import { Header } from 'mint-ui';
import { PROXY_URL } from '../../../config/env';
import { queryGoodDetail, getIsCanAssist, getAddAssistor, getGameList } from '../../../service/getData';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import { Toast } from 'mint-ui';
export default {
	name: 'assistance',
	components: { Header, Toast },
	data: function () {
		return {
			activInitiatorId: this.$route.query.activInitiatorId || '96',
			isMask: false,
			isShowCon: false,
			iscont: false, //提示内容
			cont: '',
			goodsInfo: [],
			isShowBtn: false,
			gameList: []
		};
	},
	computed: {
		freePlayUrl() {
			let t =
				this.gameList.find(v => {
					return v.content[0] && v.content[0].goto_link === 'mianfei';
				}) || {};
			return 'http://m.xubei.com/#/goodsAll?id=' + (t.id || 105);
		}
	},
	mounted() {
		this.initData();
		this.getGameList();
	},
	methods: {
		async initData() {
			let self = this;
			let data = {
				goodsId: self.$route.query.goodsId || '2831432',
				businessNo: 'xubei',
				showType: 2,
				show: 1
			};
			console.log(self.$route.query.channel);
			if (self.$route.query.channel) {
				document.cookie = 'channel=' + self.$route.query.channel + '; domain=' + PROXY_URL.domaiUrl + ';';
			}
			queryGoodDetail(data).then(res => {
				console.log(res);
				if (res.data.code == 1) {
					// if(res.data.result.detail.gamemaintain&&res.data.result.detail.gamemaintain.status=='1'){
					//     this.gamemaintain = res.data.result.detail.gamemaintain;
					//     this.btnStatus = true;
					// }else{
					//     this.btnStatus = false;
					// }

					for (var i in res.data.result.prototypelist) {
						if (res.data.result.prototypelist[i].key == 'paiweisai') {
							if (res.data.result.prototypelist[i].value == '1') {
								res.data.result.prototypelist[i].value = '允许';
							} else if (res.data.result.prototypelist[i].value == '0') {
								res.data.result.prototypelist[i].value = '不允许';
							}
						}
					}

					self.goodsInfo = res.data.result;
					self.goodsInfo.picture = res.data.result.picture;
					self.goodsInfo.prototypelist = res.data.result.prototypelist;
					self.$nextTick(function () {
						var mySwiper = new Swiper('.swiper-goodsImg', {
							loop: true,
							pagination: '.swiper-pagination',
							autoplay: 3000,
							paginationClickable: true
						});
					});
				} else {
					Toast(res.data.message);
				}
			});
		},
		getGameList() {
			getGameList({ appKey: 'app_xubei' }).then(res => {
				console.log('app_xubei', res);
				if (res.data.code == '1') {
					this.gameList = res.data.result;
				}
			});
		},
		zuliSubmit() {
			const getCookie = name => {
				var arr;
				var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
				if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
				else return null;
			};
			const phoneCookie = getCookie('iszhuli');
			if (phoneCookie == null) {
				let self = this;
				let data = {
					activInitiatorId: this.activInitiatorId
				};
				getIsCanAssist(data).then(res => {
					if (res.data.code == '1') {
						self.getZuli();
					} else {
						self.isMask = true;
						self.isShowCon = true;
						self.iscont = false;
						if (res.data.code == '1001') {
							self.cont = '这是自己的分享，让好友点击助力才有效哦 ~';
							self.isShowBtn = false;
						} else if (res.data.code == '1002') {
							self.cont = '你今天已经帮好友助力过了，请明天再来 ~';
							self.isShowBtn = true;
						}
					}
				});
			} else {
				this.isMask = true;
				this.isShowCon = true;
				this.iscont = false;
				this.cont = '24小时以内只能助力一次，您今天已经帮好友助力过了！';
				this.isShowBtn = true;
			}
		},
		getZuli() {
			let self = this;
			let data = {
				activNo: PROXY_URL.activNo,
				activInitiatorId: this.activInitiatorId
			};
			getAddAssistor(data).then(res => {
				if (res.data.code == '1') {
					self.isMask = true;
					self.isShowCon = true;
					self.iscont = true;
					self.isShowBtn = true;
					const setCookie = (name, value, day) => {
						if (day !== 0) {
							//当设置的时间等于0时，不设置expires属性，cookie在浏览器关闭后删除
							var expires = day * 24 * 60 * 60 * 1000;
							var date = new Date(+new Date() + expires);
							document.cookie = name + '=' + escape(value) + ';expires=' + date.toUTCString();
						} else {
							document.cookie = name + '=' + escape(value);
						}
					};
					setCookie('iszhuli', 'true', 1);
				} else {
					self.cont = res.data.message;
					self.isMask = true;
					self.isShowCon = true;
					self.iscont = false;
					self.isShowBtn = false;
				}
			});
		},
		closeBtn() {
			this.isMask = false;
			this.isShowCon = false;
		}
	}
};
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
input::-webkit-input-placeholder {
	/* placeholder颜色  */
	color: #999;
}
.main {
	width: 100%;
	height: 100%;
	background: #f2f2f2;
	color: #fff;
	.mint-header {
		background: #1b2838;
		line-height: px2rem(80rem);
		height: px2rem(80rem);
		font-size: px2rem(30rem);
	}
	.account_screenshot {
		padding-bottom: px2rem(90rem) !important;
	}

	.c_box {
		padding: px2rem(24rem);
		background: #fff;
		margin-bottom: px2rem(16rem);
		.title_default {
			font-size: px2rem(28rem);
			margin-bottom: px2rem(30rem);
		}
	}

	.game_detail {
		> h2 {
			font-size: px2rem(30rem);
			margin-bottom: px2rem(20rem);
		}
		.qufu {
			font-size: px2rem(26rem);
			color: #333;
			span {
				color: #666;
			}
		}
		.game_detail_item {
			line-height: px2rem(50rem);
			display: flex;
			> p {
				flex: 1;
				font-size: px2rem(24rem);
				color: #999;
			}
			> p:last-child {
				flex: none;
			}
			.price {
				font-size: px2rem(40rem);
				color: #ccc;
			}
		}
	}
	.account_detail {
		.account_detail_tab {
			width: 100%;
			tr {
				td {
					height: px2rem(66rem);
					padding: 0 px2rem(30rem);
					border: 1px solid #e5e5e5;
				}
				td:first-child {
					width: px2rem(120rem);
					text-align: center;
				}
			}
		}
	}

	.account_describe {
		p {
			word-break: break-all; /* 支持IE和chrome，FF不支持*/
			word-wrap: break-word; /* 以上三个浏览器均支持 */
		}
	}
	.rent_btn {
		position: fixed;
		width: 10rem;
		bottom: 0;
		height: px2rem(100rem);
		color: #fff;
		font-size: px2rem(36rem);
		text-align: center;
		background: #1b2838;
		z-index: 10;
	}

	.disable_btn {
		display: block;
		background: #bfbdbd !important;
	}

	.zuliBtn {
		background-image: linear-gradient(-90deg, #5592fc 7%, #6dcfff 93%);
		width: 100%;
		height: px2rem(98rem);
		line-height: px2rem(98rem);
		position: fixed;
		left: 0;
		bottom: 0;
		z-index: 10;
		font-size: px2rem(32rem);
		color: #ffffff;
	}
}

.pageModal {
	width: px2rem(540rem);
	position: fixed;
	left: 50%;
	top: 50%;
	z-index: 102;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	text-align: center;
	background: #fff;
	border-radius: 8px;
	.modalImg {
		width: px2rem(295rem);
		height: px2rem(263rem);
		padding: px2rem(32rem) 0 px2rem(46rem) 0;
	}
	.tit {
		font-size: px2rem(36rem);
		color: #333333;
		letter-spacing: 0.58px;
	}
	.con {
		font-size: px2rem(28rem);
		color: #333333;
		letter-spacing: 0.58px;
		padding: px2rem(19rem) px2rem(25rem) px2rem(42rem) px2rem(25rem);
	}
	.close {
		position: absolute;
		right: px2rem(32rem);
		top: px2rem(32rem);
		width: px2rem(30rem);
		height: px2rem(30rem);
	}
	.fbtn {
		font-size: px2rem(36rem);
		color: #00c1fb;
		letter-spacing: 0.58px;
		line-height: px2rem(98rem);
		height: px2rem(98rem);
		border-top: 1px solid#E5E5E5;
		display: block;
	}
}
.mask {
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0;
	top: 0;
	background: #000;
	opacity: 0.6;
	z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/forfree/assistance.vue